import React from "react";

import noIconImg from '../../../assets/imgs/noImage.png'
import dummyDriverImg from '../../../assets/imgs/dummyDriver.png'
import { FaBolt } from 'react-icons/fa';

const CruzeAndPartner = ({ cruze, rider, bid }) => {
  console.log("cruze",cruze)
  console.log("rider",rider)
  return (
    <div className="pt-5 pb-1">
      <h2 className="text-lg font-semibold mb-3">Selected Cruze</h2>

      {bid?.bidMode === 'A' && (
        <div className="flex items-center rounded-md bg-gray-100 p-4 lg:hidden">
          <div className="relative shrink-0">
            <img
              src={rider?.avatar_url?.trim() ? rider.avatar_url : dummyDriverImg}
              alt="Driver"
              className="h-14 w-14 rounded-full bg-white object-cover"
            />
            <span className="absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-full bg-white shadow">
              <FaBolt className="h-3 w-3" aria-label="Auto bid" />
            </span>
          </div>
          <div className="min-w-0 pl-3">
            <p className="truncate text-base font-semibold">
              {rider?.first_name} {rider?.last_name}
            </p>
            <p className="text-sm text-gray-600">
              {[
                cruze?.bodyType || cruze?.cruzeClass,
                cruze?.seatingCapacity
                  ? `${cruze.seatingCapacity} + 1 Seater`
                  : null,
              ].filter(Boolean).join(' • ')}
            </p>
          </div>
        </div>
      )}

      <div className={`${bid?.bidMode === 'A' ? 'hidden lg:block' : ''} p-4 rounded-md bg-gray-100 dark:bg-gray-800`}>
        <div className="flex items-center">
          {/* Vehicle Image */}
          <div className="w-20 flex justify-center items-center">
            {cruze?.thumbnailImage ? (
              <img
                src={cruze.thumbnailImage}
                alt="Vehicle"
                className="w-20 h-12 object-contain"
              />
            ) : (
              <img
                src={noIconImg} // Replace with your image path
                alt="No Image"
                className="w-12 h-12 rounded-full object-contain"
              />
            )}
          </div>

          {/* Vehicle Info */}
          <div className="pl-3 w-3/5">
            <p className="text-base font-semibold">{rider?.vehicle_name}</p>
            <p className="text-sm text-gray-500">
              {rider?.vehicleClass} - {rider?.vehicleColor}
            </p>
            <p className="text-sm text-gray-500">{rider?.vehicle_number}</p>
          </div>

          {/* Seating Capacity */}
          <div className="w-1/5 py-2 rounded-md bg-blue-500 text-center">
            <p className="text-white font-semibold">{rider?.vehicleSeatingCapacity}+1</p>
            <p className="text-white text-xs">Seater</p>
          </div>
        </div>

        {/* 360 View Component (You need to implement this in React.js) */}
        {/* <Cruze360View cruzeImages={rider.vehicle360View} /> */}

        {/* Rider Details */}
        <div className="flex items-center pt-3">
          {/* Driver Image */}
          <div className="w-16 flex justify-center items-center">
            {rider?.avatar_url ? (
              <img
                src={rider.avatar_url}
                alt="Driver"
                className="w-14 h-14 rounded-full object-contain"
              />
            ) : (
              <img
                src={dummyDriverImg}// Replace with your image path
                alt="Dummy Driver"
                className="w-12 h-12 rounded-full object-contain"
              />
            )}
          </div>

          {/* Driver Info */}
          <div className="pl-3 w-3/5">
            <p className="text-base font-semibold">
              {rider?.first_name} {rider?.last_name}
            </p>
            <p className="text-sm text-gray-500">Rated {rider?.rating} out of 5</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CruzeAndPartner);
